var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedSnippetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Crown",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Crown",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.514 5.022L4.002 6l3.683-4.84a.4.4 0 01.637 0L12.005 6l3.49-.987a.4.4 0 01.481.531l-2.84 7.203a.4.4 0 01-.372.253H3.242a.4.4 0 01-.372-.253L.034 5.554a.4.4 0 01.48-.532zm2.563 2.796l1.694.474 3.232-4.247 3.235 4.25 1.692-.478L11.675 11H4.332L3.077 7.818z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14a1 1 0 000 2h8a1 1 0 100-2H4z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgFeaturedSnippetIcon;